import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageStoreLayer from "../../../components/Admin/ManageStoreLayer";

const ManageStore = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageStoreLayer />
      </MasterLayout>
    </>
  );
};
export default ManageStore